<template>
  <div>
    <div
      :class="{
        'chat-messages-list-item-user': to === 'Bot',
        'chat-messages-list-item-other': to === 'User',
        'chat-messages-list-item-system': to === 'System'
      }"
    >
      <div
        :class="{
          'chat-messages-list-item-user-message': to === 'Bot',
          'chat-messages-list-item-other-message': to === 'User',
          'chat-messages-list-item-system-message': to === 'System'
        }"
      >
        <div v-if="message.type.toLocaleLowerCase() === 'text'">
          <p v-html="formatChatMessage(message)"/>
        </div>
        <div
          v-else-if="message.type.toLocaleLowerCase() === 'image'"
          class="chat-message-image-container"
          @click="openImageModal(message.fileBase)"
        >
          <img class="chat-message-image" :src="formatImageMessage(message)" />
          <div class="expand-indicator">
            <i class="fas fa-expand"></i>
          </div>
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'ptt'">
          <video controls="" name="media">
            <source :src="formatAudioMessage(message.fileBase)" type="audio/ogg">
          </video>
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'list'">
          <strong><p>{{ message.title }}</p></strong>
          <div v-for="(section, index) in message.sections" :key="index">
            <ul>
              <li v-for="row in section.rows" :key="row.rowId">
                {{ row.title }}
              </li>
            </ul>
          </div>
        </div>
        <div v-else-if="message.type.toLocaleLowerCase() === 'document'">
          <div
            class="chat-message-document"
            @click="handleDownloadFile(message)"
          >
            <span
              class="chat-message-document-icon"
            >
              <i class="fas fa-download"/>
            </span>
            <div class="chat-message-document-file">
              <span class="chat-message-document-file-name">Arquivo</span>
              <span class="chat-message-document-file-format">.{{ message.mimeType.split('/')[1] }}</span>
            </div>
          </div>
        </div>

        <div
          :class="{
            'chat-messages-list-item-user-message-notifications': to === 'Bot',
            'chat-messages-list-item-other-message-notifications': to === 'User',
            'chat-messages-list-item-system-message-notifications': to === 'System'
          }"
        >
          <div v-if="message.type.toLocaleLowerCase() === 'transferir'">
            <div class="chat-messages-actions">
              <p>Essa conversa foi transferida para {{message.text}} <i v-if="description !== null" class="fa fa-info-circle" :title="description"></i></p>
            </div>
          </div>
          <div v-else-if="message.type.toLocaleLowerCase() === 'assumir'">
            <div class="chat-messages-actions">
              <p>Essa conversa foi assumida por {{message.text}} <i v-if="description !== null" class="fa fa-info-circle" :title="description"></i></p>
            </div>
          </div>
          <div class="message-status">
            {{ moment(date).format('HH:mm') }}
            <span class="ml-1">
              <i v-if="sent" class="fas fa-check"/>
              <i v-else class="fas fa-clock"/>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isImageModalOpen" class="image-modal" @click="closeImageModal">
      <div class="image-modal-content" @click.stop>
        <img :src="currentImageSrc" alt="Expanded Image"/>
      </div>
      <div class="image-modal-footer">Fechar</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatMessage',
  props: {
    to: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    message: {
      type: Object,
      required: false
    },
    date: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    sent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isImageModalOpen: false,
      currentImageSrc: ''
    }
  },
  methods: {
    formatChatMessage (message) {
      if (!message.text) {
        return ''
      }
      return message.text.replaceAll('\n', '<br>').replaceAll(/\*\*(.*?)\*\*/g, '<b>$1</b>')
    },
    formatImageMessage (message) {
      return `data:image/jpeg;base64,${message.fileBase}`
    },
    formatAudioMessage (base64) {
      return `data:audio/ogg;base64,${base64}`
    },
    handleDownloadFile (message) {
      const { fileBase, mimeType } = message
      const blob = this.base64ToBlob(fileBase, mimeType)
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `file.${mimeType.split('/')[1]}`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    base64ToBlob (base64, mimeType) {
      const byteString = window.atob(base64)
      const arrayBuffer = new ArrayBuffer(byteString.length)
      const int8Array = new Uint8Array(arrayBuffer)

      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i)
      }

      return new Blob([int8Array], { type: mimeType })
    },
    openImageModal (fileBase) {
      this.currentImageSrc = this.formatImageMessage({ fileBase })
      this.isImageModalOpen = true
    },
    closeImageModal () {
      this.isImageModalOpen = false
    }
  }
}
</script>

<style scoped>
.chat-message-image-container {
  position: relative;
  display: inline-block;
}

.chat-message-image {
  width: 100%;
  height: auto;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.chat-message-image-container:hover .chat-message-image {
  opacity: 0.8;
}

.expand-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 10px;
  border-radius: 50%;
  font-size: 24px;
  display: none;
  justify-content: center;
  align-items: center;
}

.chat-message-image-container:hover .expand-indicator {
  display: flex;
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: auto;
}

.image-modal-content {
  position: relative;
  max-width: 70vw;
  max-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-modal-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.image-modal-footer {
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  background: rgba(0, 0, 0, 0.6);
  padding: 5px;
  border-radius: 5px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/chat/ChatMessage.vue